import { container } from "tsyringe";
import { HubToHubApiRepository } from "../../repositories/api/HubToHubApiRepository";
import ApiService from "../../services/ApiService";
import { HubToHubMapper } from "@/data/persistences/mappers/HubToHubMapper";
import { HubToHubEndpoints } from "../../endpoints/HubToHubEndpoint";
import { HubToHubPresenter } from "@/app/ui/presenters/HubToHubPresenter";

export class HubToHubComponent {
  public static init() {
    container.register<HubToHubApiRepository>(HubToHubApiRepository, {
      useFactory: (d) => {
        return new HubToHubApiRepository(
          d.resolve(ApiService),
          d.resolve(HubToHubMapper),
          d.resolve(HubToHubEndpoints)
        );
      }
    });
    container.register<HubToHubMapper>(HubToHubMapper, {
      useClass: HubToHubMapper
    });
    container.register<HubToHubPresenter>(HubToHubPresenter, {
      useFactory: (d) => {
        return new HubToHubPresenter(d.resolve(HubToHubApiRepository));
      }
    });
  }
}
